<div class="content-status container">
  <!-- <div class="row py-2 mt-1">
    <div class="col text-center" *ngIf="userServiceBase">
      <h5 class="mb-0 ">
        <span class="font-weight-bold-500" *ngIf="userServiceBase.userName">{{userServiceBase.userName}}</span>
        <span class="font-size-11" *ngIf="userServiceBase.userMobile"> ({{userServiceBase.userMobile}})</span>
      </h5>

    </div>

  </div> -->
  <div class="row">
    <div class="col"><span class="font-weight-bold-500" *ngIf="tableName">Guest</span></div>
    <div class="col"><span class="font-weight-bold-500 float-right" *ngIf="tableName">{{tableName}}</span></div>
  </div>
  <div class="row">
    <div class="col">
      <button style="border-radius: 10px !important;" type="button"
        class="btn btn-sm cart-btn-paylater font-weight-bold-500 box-shadow-none rounded" (click)="onBackClick()">
        {{'COMMON.MENU' | translate }}
      </button>
    </div>
    <div class="col">
      <button style="border-radius: 10px !important;" type="button"
        class="float-right btn btn-sm cart-btn-paylater font-weight-bold-500 box-shadow-none rounded"
        (click)="overlayOpen()">
        {{'COMMON.HELP' | translate }}
      </button>
    </div>

  </div>

  <div class="row mt-2" *ngIf="statusinput">
    <div class="col text-center">
      <h6 class="text-warning font-weight-bold-500 status-box" *ngIf="statusinput.OrderStatus === 'DRAFT'">
        {{'HISTORY_PAGE.PLACED_WAIT_CONFIRM' | translate }}
      </h6>
      <h6 class="text-success font-weight-bold-500 h4" *ngIf="statusinput.OrderStatus === 'SCHEDULED'">
        Order <span class="">{{orderStatus}}</span>
      </h6>
      <h6 class="text-success font-weight-bold-500 h4" *ngIf="statusinput.OrderStatus === 'INPROGRESS'">
        Order <span class="">{{orderStatus}}</span>
      </h6>
      <h6 class="text-danger font-weight-bold-500 h4" *ngIf="statusinput.OrderStatus === 'REJECT'">
        Order <span class="">{{orderStatus}}</span>
      </h6>
      <h6 class="text-success font-weight-bold-500 status-box" *ngIf="statusinput.OrderStatus === 'OPEN'">
        Your order received and sent to kitchen
      </h6>
      <h6 class="text-success font-weight-bold-500 h4" *ngIf="statusinput.OrderStatus === 'READY'">
        Order <span class="">{{orderStatus}}</span>
      </h6>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <div class="row no-gutters" *ngIf="userSelectedStore && statusinput.OrderStatus === 'INPROGRESS'">
        <div class="col">
          <label *ngIf="userSelectedStore.serviceDatetime">{{progressStartTime}}</label>
        </div>
        <div class="col text-right">
          <div>
            <label *ngIf="userSelectedStore.serviceEstimatedDatetime">{{progressEndTime}}</label>
          </div>
        </div>
      </div>
      <div class="row pb-1">
        <div class="col">
          <div class="progress">
            <div class="progress-bar progress-bar-striped progress-bar-animated bg-success" role="progressbar"
              aria-valuenow="statusWidthNumber" aria-valuemin="0" aria-valuemax="100" [style.width]="statusWidth"></div>
          </div>
        </div>
      </div>

      <div class="row" *ngIf="orderStatus !== 'Rejected'">
        <div class="col pr-1">
          <button
            class="btn cart-btn-paylater btn-block btn-sm box-shadow-none rounded d-flex align-items-center justify-content-center"
            (click)="onBackClick()">
            <!-- {{'HISTORY_PAGE.ORDER_MORE_ITEMS' | translate }} -->
            Create New Order
            <i class="far icon-order-inline p-4 me-2"></i>
          </button>
        </div>
        <div class="col pl-1">
          <button
            class="btn cart-btn-paylater btn-block btn-sm box-shadow-none rounded d-flex align-items-center justify-content-center"
            (click)="onAssistanceClick(assistance)">
            <i class="far icon-bell-inline p-4 me-2"></i>
            {{'HISTORY_PAGE.ASK_ASSISTANCE' | translate }}
          </button>
        </div>
      </div>

      <div class="row no-gutters mt-2" style="display: none;">
        <div class="col" *ngIf="orderStatus !== 'Rejected'">
          <label class="font-weight-bold-500 mb-0">{{statusMessage}}</label>
        </div>
        <div class="col" *ngIf="orderStatus === 'Rejected'">
          <div>
            <label class="font-weight-bold-500 mb-0">Sorry your order is rejected because : {{rejectreason}} (any
              payment made will be refunded as soon)</label>
          </div>
          <label class="font-weight-bold-500 mb-0">You may call olarme customer support for further information</label>
        </div>
        <div class="col text-right font-weight-bold-500" *ngIf="statusinput.OrderStatus === 'INPROGRESS'">
          <div *ngIf="timeleft">
            <label class="mb-0">Expected in {{timeleft}}</label>
          </div>
        </div>
      </div>
      <div *ngIf="false" class="row pb-2 mt-1">
        <div class="col text-center">
          <div class="alert alert-warning" role="alert">
            {{'HISTORY_PAGE.REFER_FRIEND' | translate }}
          </div>
        </div>
      </div>

      <!-- new UI -->
      <ng-container *ngIf="orders.length">
        <div class="card shadow-sm mt-50 mb-50 mt-3" *ngFor="let item of orders">
          <!-- <div class="col d-flex"><span class="text-muted" id="orderno">Order #{{orderId}}</span></div> -->

          <!-- <div class="title mx-auto text-success"> Thank you for your order! </div> -->

          <div class="col-12 background-grey pt-2 mb-2">
            <div class="col">
              <div class="row">
                <div class="col-9">
                  <button class="btn cart-btn-paylater btn-sm" *ngIf="!item.paid" (click)="addMoreItem(item)">Add more
                    items</button><br>
                  <!-- <button class="btn cart-btn-paylater btn-sm" (click)="repeat(item)">Repeat</button><br> -->
                  <span class="order-status mt-2 mb-1"
                    [ngClass]="{'unpaid': !item.paid, 'paid': item.paid}"><b>{{item.paid ?
                      ('HISTORY_PAGE.PAID' | translate) :
                      ('HISTORY_PAGE.UNPAID' | translate)}}</b></span><br>

                  <h6>

                    <span class="font-weight-bold">{{ item.type === 'DINE_IN' ? ('Table ' + (item.table ? item.table :
                      '') + ': ') : 'Take Away:' }}
                    </span>
                    {{'HISTORY_PAGE.TICKET' | translate }} <span class="font-weight-bold-500">
                      #{{item.orderId}}
                    </span>

                  </h6>
                </div>
                <div class="col-3 d-flex justify-content-end align-items-center" (click)="onViewReceiptClick(receipt)">
                  <!-- <span [ngClass]="{'icon-unpaid-inline': !item.paid, 'icon-paid-inline': item.paid}"
                    class="far p-4  float-right"></span> -->

                  <div class="icon-wrapper">
                    <span [ngClass]="{'icon-unpaid-inline': !item.paid, 'icon-paid-inline': item.paid}"></span>
                  </div>

                  <!-- <span class="ribbon" [ngClass]="{'unpaid': !item.paid, 'paid': item.paid}">{{item.paid ? 'PAID' :
                    'UNPAID'}}</span> -->
                </div>
              </div>
            </div>
          </div>

          <div class="main" *ngIf="item.orderInfo">
            <span id="sub-title" style="display: none;">
              <p><b>Payment Summary</b></p>
            </span>
            <div class="row row-main" *ngFor="let item of item.orderInfo.items;let i=index">
              <div class="col-9">
                <div class="row d-flex ml-2">
                  <p><b>{{item.quantity}} x {{item.item_name}}</b></p>
                </div>
                <div class="row d-flex ml-3" *ngIf="item.discounts">
                  <span class="text-muted fa-xs-small-70">DISCOUNT ({{item.discounts.name}})</span>
                </div>
                <div class="row d-flex ml-3" *ngFor="let mod of item.modifiers;let j=index">
                  <div class="col-12 p-0 row-option">
                    <span class="text-info fa-xs-small-70">{{item.quantity}} x {{mod.modifier_option_name}}
                      {{(item.quantity * mod.modifier_option_price)?.toFixed(2)}}</span>
                  </div>
                  <div class="col-12 p-0 row-option" *ngFor="let op of mod.options;let x=index">
                    <span class="text-muted fa-xs-small-70 ml-2">{{item.quantity}} x {{op.modifier_option_name}}
                      {{(item.quantity* mod.modifier_option_price)?.toFixed(2)}}</span>
                  </div>
                </div>
                <div class="row d-flex ml-3" *ngIf="item.remarks">
                  <span class="text-muted fa-xs-small-70"> &gt;&gt;{{item.remarks}}&lt;&lt; </span>
                </div>
                <!-- <div class="row d-flex ml-2">
                  <p><b>x{{item.quantity}}</b></p>
                </div> -->
              </div>
              <div class="col-3">

                <div class="row d-flex justify-content-end">
                  <p><b><span
                        *ngIf="settings && settings.company_currency_position === 'FRONT'">{{settings.company_currency}}</span>
                      {{(item.quantity * item.price)?.toFixed(2)}}
                      <span
                        *ngIf="settings && settings.company_currency_position === 'BACK'">{{settings.company_currency}}</span></b>
                  </p>
                </div>
                <div class="row d-flex justify-content-end text-danger" *ngIf="item.discounts">
                  <p><b><span
                        *ngIf="settings && settings.company_currency_position === 'FRONT'">{{settings.company_currency}}</span>
                      - {{(item.discounts.price)?.toFixed(2)}}
                      <span
                        *ngIf="settings && settings.company_currency_position === 'BACK'">{{settings.company_currency}}</span></b>
                  </p>
                </div>
              </div>
            </div>
            <!-- <hr> -->
            <div class="total mt-3">
              <div class="row">
                <div class="col"> <b> Subtotal:</b> </div>
                <div class="col d-flex justify-content-end p-0"> <b><span
                      *ngIf="settings && settings.company_currency_position === 'FRONT'">{{settings.company_currency}}</span>
                    {{item.subTotal}} <span
                      *ngIf="settings && settings.company_currency_position === 'BACK'">{{settings.company_currency}}</span></b>
                </div>
              </div>
              <div class="row" *ngIf="item.totalDiscount > 0">
                <div class="col"> <b> Discount:</b> </div>
                <div class="col d-flex justify-content-end p-0"> <b><span
                      *ngIf="settings && settings.company_currency_position === 'FRONT'">{{settings.company_currency}}</span>
                    {{item.totalDiscount.toFixed(2)}} <span
                      *ngIf="settings && settings.company_currency_position === 'BACK'">{{settings.company_currency}}</span></b>
                </div>
              </div>
              <div class="row" *ngIf="item.totalEntireDiscounts > 0">
                <div class="col"> <b>Order Discount:</b> </div>
                <div class="col d-flex justify-content-end p-0"> <b><span
                      *ngIf="settings && settings.company_currency_position === 'FRONT'">{{settings.company_currency}}</span>
                    {{item.totalEntireDiscounts.toFixed(2)}} <span
                      *ngIf="settings && settings.company_currency_position === 'BACK'">{{settings.company_currency}}</span></b>
                </div>
              </div>
              <div class="row" *ngIf="item.loyaltyDiscount > 0">
                <div class="col"> <b>Loyalty Discount:</b> </div>
                <div class="col d-flex justify-content-end p-0"> <b><span
                      *ngIf="settings && settings.company_currency_position === 'FRONT'">{{settings.company_currency}}</span>
                    {{item.loyaltyDiscount.toFixed(2)}} <span
                      *ngIf="settings && settings.company_currency_position === 'BACK'">{{settings.company_currency}}</span></b>
                </div>
              </div>
              <ng-container *ngFor="let item of item.serviceCharges">
                <div class="row" *ngIf="item.amountSurcharge > 0">
                  <div class="col">
                    <span><b>{{item.surchargeName}}</b></span>
                  </div>
                  <div class="col d-flex justify-content-end p-0"> <b><span
                        *ngIf="settings && settings.company_currency_position === 'FRONT'">{{settings.company_currency}}</span>
                      {{item.amountSurcharge.toFixed(2)}} <span
                        *ngIf="settings && settings.company_currency_position === 'BACK'">{{settings.company_currency}}</span></b>
                  </div>

                </div>
                <div class="row px-2 mr-1 line-height-1 mb-2px" *ngIf="item.surchargeTax > 0">
                  <div class="col-7 pr-4">
                    <span>Surcharge Tax</span>
                  </div>
                  <div class="col-5 text-right pr-2">
                    <span *ngIf="this.settings.company_sell_price_tax === 'TAX_EX'">
                      {{item.surchargeTax.toFixed(2)}}
                    </span>
                    <span *ngIf="this.settings.company_sell_price_tax === 'TAX_IN'">
                      ({{item.surchargeTax.toFixed(2)}})
                    </span>
                  </div>
                </div>
              </ng-container>
              <ng-container *ngFor="let item of item.taxs">
                <div class="row" *ngIf="item.tax_amount > 0">
                  <div class="col">
                    <span><b>{{item.tax_name}}</b></span>
                  </div>
                  <div class="col d-flex justify-content-end p-0"> <b><span
                        *ngIf="settings && settings.company_currency_position === 'FRONT'">{{settings.company_currency}}</span>
                      {{item.tax_amount.toFixed(2)}} <span
                        *ngIf="settings && settings.company_currency_position === 'BACK'">{{settings.company_currency}}</span></b>
                  </div>

                </div>
              </ng-container>
              <div class="row">
                <div class="col"> <b> Total:</b> </div>
                <div class="col d-flex justify-content-end p-0"> <b><span
                      *ngIf="settings && settings.company_currency_position === 'FRONT'">{{settings.company_currency}}</span>
                    {{item.totalPrice}} <span
                      *ngIf="settings && settings.company_currency_position === 'BACK'">{{settings.company_currency}}</span></b>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-container>

      <!-- History for login user -->

      <ng-container *ngIf="customerHistory.length">
        <div class="row">
          <div class="col">
            Your previous purchases
          </div>
        </div>
        <div class="card shadow-sm mt-50 mb-50 mb-2" *ngFor="let item of customerHistory;let i=index">
          <!-- <div class="col d-flex"><span class="text-muted" id="orderno">Order #{{orderId}}</span></div> -->

          <!-- <div class="title mx-auto text-success"> Thank you for your order! </div> -->

          <div class="col-12 background-white pt-2">
            <div class="col">
              <div class="row">
                <div class="col-9">
                  <!-- <button class="btn cart-btn-paylater btn-sm" *ngIf="!item.paid" (click)="addMoreItem(item)">Add more
                    items</button><br> -->
                  <!-- <button class="btn cart-btn-paylater btn-sm" (click)="repeat(item)">Repeat</button><br> -->
                  <div class="status-row">
                    <span class="order-status" [ngClass]="{'unpaid': !item.paid, 'paid': item.paid }"><b>{{item.paid ?
                        ('HISTORY_PAGE.PAID' | translate) :
                        ('HISTORY_PAGE.UNPAID' | translate)}}</b></span>
                    <!-- Fulfillment status -->
                    <span class="order-status" [ngClass]="{'rejected': item.orderStatus === 'REJECT', 
                      'completed': item.orderStatus === 'COMPLETE',
                    'inprogress': item.orderStatus === 'INPROGRESS' }"><b>{{item.orderStatus}}</b></span>
                  </div>
                  {{item.date}}<br>


                  <span class="font-weight-bold">{{ item.type === 'DINE_IN' ? ('Table ' + (item.table ? item.table :
                    '') + ': ') : 'Take Away:' }}
                  </span>
                  {{'HISTORY_PAGE.TICKET' | translate }} <span class="font-weight-bold-500">
                    #{{item.orderId}}
                  </span> <br>


                  <span class="font-weight-bold"
                    *ngIf="settings && settings.company_currency_position === 'FRONT'">{{settings.company_currency}}</span>
                  <span class="font-weight-bold ml-1 mr-1">{{item.totalPrice}}</span>
                  <span class="font-weight-bold"
                    *ngIf="settings && settings.company_currency_position === 'BACK'">{{settings.company_currency}}</span>
                </div>
                <div class="col-3 d-flex justify-content-end align-items-center p-0">
                  <button class="btn btn-detail cursor" *ngIf="!item.orderInfo" (click)="seeDetails(item,i)">See
                    Details</button>
                  <!-- <button class="btn cart-btn-paylater btn-sm" (click)="repeat(item)">Repeat</button> -->
                </div>
              </div>
            </div>
          </div>

          <div class="main" *ngIf="item.orderInfo">
            <span id="sub-title" style="display: none;">
              <p><b>Payment Summary</b></p>
            </span>
            <div class="row row-main" *ngFor="let item of item.orderInfo.items;let i=index">
              <div class="col-9">
                <div class="row d-flex ml-2">
                  <p><b>{{item.quantity}} x {{item.item_name}}</b></p>
                </div>
                <div class="row d-flex ml-3" *ngIf="item.discounts">
                  <span class="text-muted fa-xs-small-70">DISCOUNT ({{item.discounts.name}})</span>
                </div>
                <div class="row d-flex ml-3" *ngFor="let mod of item.modifiers;let j=index">
                  <div class="col-12 p-0 row-option">
                    <span class="text-info fa-xs-small-70">{{item.quantity}} x {{mod.modifier_option_name}}
                      {{(item.quantity * mod.modifier_option_price)?.toFixed(2)}}</span>
                  </div>
                  <div class="col-12 p-0 row-option" *ngFor="let op of mod.options;let x=index">
                    <span class="text-muted fa-xs-small-70 ml-2">{{item.quantity}} x {{op.modifier_option_name}}
                      {{(item.quantity* mod.modifier_option_price)?.toFixed(2)}}</span>
                  </div>
                </div>
                <div class="row d-flex ml-3" *ngIf="item.remarks">
                  <span class="text-muted fa-xs-small-70"> &gt;&gt;{{item.remarks}}&lt;&lt; </span>
                </div>
                <!-- <div class="row d-flex ml-2">
                  <p><b>x{{item.quantity}}</b></p>
                </div> -->
              </div>
              <div class="col-3">

                <div class="row d-flex justify-content-end">
                  <p><b><span
                        *ngIf="settings && settings.company_currency_position === 'FRONT'">{{settings.company_currency}}</span>
                      {{(item.quantity * item.price)?.toFixed(2)}}
                      <span
                        *ngIf="settings && settings.company_currency_position === 'BACK'">{{settings.company_currency}}</span></b>
                  </p>
                </div>
                <div class="row d-flex justify-content-end text-danger" *ngIf="item.discounts">
                  <p><b><span
                        *ngIf="settings && settings.company_currency_position === 'FRONT'">{{settings.company_currency}}</span>
                      - {{(item.discounts.price)?.toFixed(2)}}
                      <span
                        *ngIf="settings && settings.company_currency_position === 'BACK'">{{settings.company_currency}}</span></b>
                  </p>
                </div>
              </div>
            </div>
            <!-- <hr> -->
            <div class="total mt-3">
              <div class="row">
                <div class="col"> <b> Subtotal:</b> </div>
                <div class="col d-flex justify-content-end p-0"> <b><span
                      *ngIf="settings && settings.company_currency_position === 'FRONT'">{{settings.company_currency}}</span>
                    {{item.subTotal}} <span
                      *ngIf="settings && settings.company_currency_position === 'BACK'">{{settings.company_currency}}</span></b>
                </div>
              </div>
              <div class="row" *ngIf="item.totalDiscount > 0">
                <div class="col"> <b> Discount:</b> </div>
                <div class="col d-flex justify-content-end p-0"> <b><span
                      *ngIf="settings && settings.company_currency_position === 'FRONT'">{{settings.company_currency}}</span>
                    {{item.totalDiscount.toFixed(2)}} <span
                      *ngIf="settings && settings.company_currency_position === 'BACK'">{{settings.company_currency}}</span></b>
                </div>
              </div>
              <div class="row" *ngIf="item.totalEntireDiscounts > 0">
                <div class="col"> <b>Order Discount:</b> </div>
                <div class="col d-flex justify-content-end p-0"> <b><span
                      *ngIf="settings && settings.company_currency_position === 'FRONT'">{{settings.company_currency}}</span>
                    {{item.totalEntireDiscounts.toFixed(2)}} <span
                      *ngIf="settings && settings.company_currency_position === 'BACK'">{{settings.company_currency}}</span></b>
                </div>
              </div>
              <div class="row" *ngIf="item.loyaltyDiscount > 0">
                <div class="col"> <b>Loyalty Discount:</b> </div>
                <div class="col d-flex justify-content-end p-0"> <b><span
                      *ngIf="settings && settings.company_currency_position === 'FRONT'">{{settings.company_currency}}</span>
                    {{item.loyaltyDiscount.toFixed(2)}} <span
                      *ngIf="settings && settings.company_currency_position === 'BACK'">{{settings.company_currency}}</span></b>
                </div>
              </div>
              <ng-container *ngFor="let item of item.serviceCharges">
                <div class="row" *ngIf="item.amountSurcharge > 0">
                  <div class="col">
                    <span><b>{{item.surchargeName}}</b></span>
                  </div>
                  <div class="col d-flex justify-content-end p-0"> <b><span
                        *ngIf="settings && settings.company_currency_position === 'FRONT'">{{settings.company_currency}}</span>
                      {{item.amountSurcharge.toFixed(2)}} <span
                        *ngIf="settings && settings.company_currency_position === 'BACK'">{{settings.company_currency}}</span></b>
                  </div>

                </div>
                <div class="row px-2 mr-1 line-height-1 mb-2px" *ngIf="item.surchargeTax > 0">
                  <div class="col-7 pr-4">
                    <span>Surcharge Tax</span>
                  </div>
                  <div class="col-5 text-right pr-2">
                    <span *ngIf="this.settings.company_sell_price_tax === 'TAX_EX'">
                      {{item.surchargeTax.toFixed(2)}}
                    </span>
                    <span *ngIf="this.settings.company_sell_price_tax === 'TAX_IN'">
                      ({{item.surchargeTax.toFixed(2)}})
                    </span>
                  </div>
                </div>
              </ng-container>
              <ng-container *ngFor="let item of item.taxs">
                <div class="row" *ngIf="item.tax_amount > 0">
                  <div class="col">
                    <span><b>{{item.tax_name}}</b></span>
                  </div>
                  <div class="col d-flex justify-content-end p-0"> <b><span
                        *ngIf="settings && settings.company_currency_position === 'FRONT'">{{settings.company_currency}}</span>
                      {{item.tax_amount.toFixed(2)}} <span
                        *ngIf="settings && settings.company_currency_position === 'BACK'">{{settings.company_currency}}</span></b>
                  </div>

                </div>
              </ng-container>
              <div class="row" *ngIf="item.roundoff_amount !== 0">
                <div class="col"> <b> Rounding off:</b> </div>
                <div class="col d-flex justify-content-end p-0"> <b><span
                      *ngIf="settings && settings.company_currency_position === 'FRONT'">{{settings.company_currency}}</span>
                    {{item.roundoff_amount.toFixed(2)}} <span
                      *ngIf="settings && settings.company_currency_position === 'BACK'">{{settings.company_currency}}</span></b>
                </div>
              </div>
              <div class="row">
                <div class="col"> <b> Total:</b> </div>
                <div class="col d-flex justify-content-end p-0"> <b><span
                      *ngIf="settings && settings.company_currency_position === 'FRONT'">{{settings.company_currency}}</span>
                    {{item.totalPrice}} <span
                      *ngIf="settings && settings.company_currency_position === 'BACK'">{{settings.company_currency}}</span></b>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-container>

    </div>
  </div>




  <br />
  <br />
  <br />
  <br />
</div>
<!-- <app-ecom-footer class="footer"></app-ecom-footer> -->



<ng-template #assistance>
  <div class="modal-body">
    <div class="container">
      <div class="row">
        <div class="col-3">
          <i class="mt-2 far icon-soon-inline p-4"></i>
        </div>
        <div class="col-9 d-flex flex-column align-items-start">
          <b class="mt-3">{{'HISTORY_PAGE.DEAR_CUSTOMER' | translate }}</b>
          <p>{{'HISTORY_PAGE.THANKS_FOR_PATIENCE' | translate }}</p>
        </div>
      </div>
    </div>

  </div>
</ng-template>

<ng-template #sendEmail>
  <div class="modal-body">
    <div class="row form-group">
      <div class="col text-center">
        <label class="font-weight-bold-500 h5" for="">Email Reciept</label>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <input type="text" [(ngModel)]="invoiceEmail" class="form-control" placeholder="youremail@mail.com">
      </div>
      <div class="col-5 text-right">
        <button class="btn cart-btn-paylater font-weight-bold-500 box-shadow-none mr-2 rounded pl-4 pr-4" type="button"
          (click)="onSendEmailClick()">
          Send Email
        </button>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <span [ngClass]="{'text-success': invoiceRequest, 'text-danger': !invoiceRequest}">{{invoiceMsg}}</span>
      </div>
    </div>
  </div>
</ng-template>

<app-loading-component></app-loading-component>


<div class="overlay" *ngIf="overlayDisplay">
  <app-ecom-contact-us (submitted)="contactUsEventEmitter($event)"></app-ecom-contact-us>
</div>

<ng-template #displayPayAtCounter>
  <div class="modal-body modal-styles">
    <div class="row">
      <div class="col text-center">
        <h4 class="text-danger" style="font-family: Arial-Nova;">{{'HISTORY_PAGE.IMPORTANT_NOTICE' | translate }}</h4>
      </div>
    </div>
    <div class="row">
      <div class="col text-center m-2">
        <h5 style="font-family: Arial-Nova;">{{'HISTORY_PAGE.PROCEED_TO_COUNTER' | translate }}
        </h5>
      </div>
    </div>
    <div class="row">
      <div class="col text-center">
        <button style="border-radius: 10px !important;" type="button"
          class="btn cart-btn-paylater font-weight-bold-500 box-shadow-none mr-2 rounded pl-4 pr-4"
          (click)="closePayAtCounter()">
          Noted, Thank You
        </button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #displayPoints>
  <div class="modal-body modal-loyalty-color">

    <div class="row">
      <div class="col text-center">
        <div>
          <label class="h6 text-yellow">CONGRATULATIONS</label>
        </div>
      </div>
      <div class="col-1">
        <button style="margin-top: -10px !important;" type="button" class="close close-button text-white mr-2"
          data-dismiss="modal" aria-label="Close" (click)="closePoint()">
          <span aria-hidden="true" style="font-size: 40px !important;">&times;</span>
        </button>
      </div>
    </div>
    <div class="row form-group" *ngIf="isCustomer">
      <div class="col text-white text-center">

        <span>
          You have earned {{point}} points on this purchase, and they will be
          added to your account
        </span>

      </div>
    </div>

    <div class="row form-group" *ngIf="!isCustomer">
      <div class="col text-white text-center">

        <span>
          You have earned {{point}} points on this purchase. To enjoy attractive
          rewards, join Loyalty now.
        </span>

      </div>

    </div>
    <div class="row form-group" *ngIf="!isCustomer">
      <div class="col text-center">
        <button (click)="joinNow()" style="background-color: #1f487c !important;border-radius: 1.25rem !important;"
          class="btn cart-btn-paylater text-yellow box-shadow-none" type="button">
          JOIN NOW
        </button>
      </div>
    </div>
  </div>
</ng-template>